import { useFormSubmit } from '@/hooks/useFormSubmit';

const SUBSCRIBE_ADDR = 'https://readdy.ai/api/form/da1vivdv7gurs51ef1t0';

export default function NewsletterForm() {
  const { submitting, success, error, handleSubmit } = useFormSubmit(SUBSCRIBE_ADDR);

  return (
    <form className="flex flex-col gap-2.5" data-readdy-form onSubmit={handleSubmit}>
      {success ? (
        <div className="px-4 py-3 rounded-md bg-secondary-100 text-secondary-900 text-sm">
          <i className="ri-checkbox-circle-line mr-1.5"></i>订阅成功，感谢关注今日同人库！
        </div>
      ) : (
        <>
          <input
            type="email"
            name="email"
            required
            placeholder="请输入你的邮箱"
            className="h-11 px-4 rounded-md bg-background-700 text-background-100 text-sm placeholder:text-background-400 outline-none focus:ring-2 focus:ring-primary-400"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            placeholder=""
          />
          {error && <p className="text-xs text-accent-300">{error}</p>}
          <button
            type="submit"
            disabled={submitting}
            className="h-11 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 disabled:opacity-60 transition-colors whitespace-nowrap cursor-pointer"
          >
            {submitting ? '提交中…' : '订阅更新提醒'}
          </button>
        </>
      )}
    </form>
  );
}